import { render, staticRenderFns } from "./HotPlayersWidget.vue?vue&type=template&id=b469a07c"
import script from "./HotPlayersWidget.vue?vue&type=script&lang=js"
export * from "./HotPlayersWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports